import { memo } from 'react'
import { useSelector } from 'react-redux'

import iRedeemHealthIcon from '../assets/rewards/iredeemhealth.png'
import myLabsIcon from '../assets/rewards/mylabs-direct.png'
import truthbrushTracker from '../assets/rewards/truthbrush-tracker.png'
import truthbrush from '../assets/rewards/truthbrush.png'
import zDental from '../assets/rewards/z-dental.png'
import EarnRewardCards from '../components/earnPoints/EarnRewardCards'
import {
  iRedeemEarnUrl,
  myLabsUrl,
  truthbrushUrl,
  zDentalUrl
} from '../util/brand.helpers'

// @TODO: the following design can be reused for the other LWAs in future.
// For now using only for moda_health LWA.
const HowToEarnRewardsWrapper = ({ t, tokenSymbol, ...restProps }) => {
  const authId = useSelector(
    (state) => state.accountReducer.accountProfile.authId
  )
  return (
    <EarnRewardCards
      data={[
        {
          label: 'buy-truthbrush-tracker',
          description: `$1 = 10 ${tokenSymbol}`,
          image: truthbrush,
          link: truthbrushUrl()
        },
        {
          label: 'brush-your-teeth',
          description: `10 ${tokenSymbol} / day`,
          image: truthbrushTracker,
          link: truthbrushUrl()
        },
        {
          label: 'buy-zdental',
          description: `$1 = 10 ${tokenSymbol}`,
          image: zDental,
          link: zDentalUrl()
        },
        {
          label: 'iredeemhealth',
          description: `$1 = 10 ${tokenSymbol}`,
          image: iRedeemHealthIcon,
          link: iRedeemEarnUrl(authId)
        },
        {
          label: 'mylabs',
          description: `$1 = 10 ${tokenSymbol}`,
          image: myLabsIcon,
          link: myLabsUrl()
        }
      ]}
      t={t}
      {...restProps}
    />
  )
}

export default memo(HowToEarnRewardsWrapper)
